import React from 'react';
import classnames from 'classnames';
import { ActionButton } from '@fluentui/react';
import { createUseStyles } from 'react-jss';
import { PlaygroundTheme } from '../../Theme';
import { useIsVivara } from '../../hooks/useIsVivara';
import { vivaraIcon } from '../../Assets';

interface ILogoProps {
  text: React.ReactNode;
  size: 'small' | 'large';
  className?: string;
  onClick?: () => void;
}

const useStyles = createUseStyles<string, unknown, PlaygroundTheme>(() => ({
  logo: {
    borderRadius: 100,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#fff',
    fontFamily: 'Segoe UI',
    '&:hover': {
      color: '#fff',
    },
    '& span': {
      verticalAlign: 'middle',
      weight: 600,
      display: 'flex',
      alignItems: 'center',
    },
    '&.large': {
      width: 73,
      height: 73,
      '& span': {
        lineHeight: '38px',
        fontSize: 16,
      },
    },
    '&.small': {
      width: 32,
      height: 32,
      '& span': {
        lineHeight: '38px',
        fontSize: 11,
      },
    },
    '& svg': {
      width: 29,
    },
  },
}));

export const Logo: React.FC<ILogoProps> = ({
  text,
  size,
  className: customClassName,
  onClick,
}) => {
  const classes = useStyles();
  const isVivara = useIsVivara();
  const className = classnames(classes.logo, isVivara && 'is-vivara', size, customClassName);

  return onClick ? (
    <ActionButton className={className} onClick={onClick}>
      {vivaraIcon}
    </ActionButton>
  ) : (
    <div className={className}>
      <span>{text}</span>
    </div>
  );
};
